var NumberFlip = /** @class */ (function () {
    function NumberFlip(_a) {
        var rootElement = _a.rootElement, _b = _a.newNumber, newNumber = _b === void 0 ? 0 : _b, _c = _a.durationFlip, durationFlip = _c === void 0 ? 1000 : _c, _d = _a.durationOpacity, durationOpacity = _d === void 0 ? 200 : _d, clearRootElement = _a.clearRootElement;
        this.wrapperClassname = 'numberflip-digit-container';
        this.digitClassname = 'numberflip-digit-container-value';
        this.rootElement = rootElement;
        this.newNumber = newNumber;
        this.durationFlip = durationFlip;
        this.durationOpacity = durationOpacity;
        if (this.rootElement) {
            if (clearRootElement) {
                this.rootElement.replaceChildren();
            }
            this.rootElement.style.display = 'flex';
        }
    }
    /**
     *  handels the process of changing the current number to a new number
     */
    NumberFlip.prototype.setNumberTo = function (_a) {
        var newNumber = _a.newNumber, _b = _a.rootElement, rootElement = _b === void 0 ? this.rootElement : _b, _c = _a.durationFlip, durationFlip = _c === void 0 ? this.durationFlip : _c, _d = _a.durationOpacity, durationOpacity = _d === void 0 ? this.durationOpacity : _d, _e = _a.clearRootElement, clearRootElement = _e === void 0 ? false : _e;
        this.constructor({
            newNumber: newNumber,
            rootElement: rootElement,
            durationFlip: durationFlip,
            durationOpacity: durationOpacity,
            clearRootElement: clearRootElement,
        });
        if (!this.rootElement) {
            throw new Error('No root element provided');
        }
        this.rootElement.style.display = 'flex';
        this.createOrRemoveDigitContainers();
        this.setDigitInContainers();
    };
    /**
     * handels the process of changing the current number to a new number on multiple elements
     */
    NumberFlip.prototype.setNumberForElements = function (_a) {
        var elements = _a.elements, _b = _a.attributeName, attributeName = _b === void 0 ? 'data-number' : _b, durationFlip = _a.durationFlip, durationOpacity = _a.durationOpacity, _c = _a.clearRootElement, clearRootElement = _c === void 0 ? false : _c;
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            var newNumber = Number(element.getAttribute(attributeName));
            if (newNumber !== null) {
                this.setNumberTo({
                    newNumber: newNumber,
                    rootElement: element,
                    durationFlip: durationFlip,
                    durationOpacity: durationOpacity,
                    clearRootElement: clearRootElement,
                });
            }
        }
    };
    /**
     * returns an array of digits from the currently set number
     */
    NumberFlip.prototype.getDigitsFromNumber = function () {
        var digits = this.newNumber.toString().split('');
        return digits.map(Number);
    };
    /**
     * Creates one element for each digit inside the provided root element.
     * Should there be more digit containers than digits, the unnecessary digit containers will be removed.
     */
    NumberFlip.prototype.createOrRemoveDigitContainers = function () {
        if (this.rootElement) {
            var countOfDigits = this.getDigitsFromNumber().length;
            var countOfDigitContainers = this.rootElement.getElementsByClassName(this.wrapperClassname).length;
            // Create digit containers
            while (countOfDigitContainers < countOfDigits) {
                this.rootElement.insertAdjacentHTML('afterbegin', "<div class=\"".concat(this.wrapperClassname, "\">\n            <span class=\"").concat(this.digitClassname, "-hidden\">0</span>\n            <div class=\"").concat(this.digitClassname, "\" style=\"transform: translateY(-100%);\">\n              <span>9</span>\n              <span>8</span>\n              <span>7</span>\n              <span>6</span>\n              <span>5</span>\n              <span>4</span>\n              <span>3</span>\n              <span>2</span>\n              <span>1</span>\n              <span>0</span>\n            </div>\n          </div>"));
                countOfDigitContainers++;
            }
            // Remove unnecessary digit containers
            if (countOfDigitContainers > countOfDigits) {
                var digitContainers = this.rootElement.getElementsByClassName(this.digitClassname);
                var _loop_1 = function (i) {
                    var digitContainer = digitContainers[i].parentElement;
                    digitContainer.style.animationDuration = this_1.durationOpacity + 'ms';
                    digitContainer.style.animationName = 'fade-out';
                    // Wait for fade out animation to finish before removing the element
                    setTimeout(function () { return digitContainer.remove(); }, this_1.durationOpacity);
                };
                var this_1 = this;
                for (var i = countOfDigits; i < digitContainers.length; i++) {
                    _loop_1(i);
                }
            }
        }
    };
    /**
     * Sets the digit in the digit containers to the new number
     */
    NumberFlip.prototype.setDigitInContainers = function () {
        if (this.rootElement) {
            var digits = this.getDigitsFromNumber();
            var digitContainers = this.rootElement.getElementsByClassName(this.digitClassname);
            var _loop_2 = function (i) {
                var digitContainer = digitContainers[i];
                var translate = this_2.calculateTranslateY(digits[i]);
                setTimeout(function () { return (digitContainer.style.transform = "translateY(".concat(translate, "%)")); }, 0);
            };
            var this_2 = this;
            for (var i = 0; i < digitContainers.length; i++) {
                _loop_2(i);
            }
        }
    };
    NumberFlip.prototype.calculateTranslateY = function (digit) {
        return (-90 + digit * 10).toString();
    };
    return NumberFlip;
}());

